<template>
  <div class="main">
    <Header
      :logo-white="false"
      :button="true"
      :background="true"
    />
    <div class="flex-column flex-grid--full">
      <div class="video__bg flex-column flex-grid--full align-center">
        <div class="video__content">
          <h1>Een woning {{funnel}}</h1>
          <h3>Lees verder</h3>
        </div>
        <!-- <a class="text-center btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1128957&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow"> Huurwoningmarktplaats </a> -->
        <span class="mouse" />
      </div>
      <div class="flex-grid ">
        <div
          v-for="(Toelichting, r) in getFunnel_toelichting.stories.slice()"
          :key="r"
          class="bottom"
        >
          <div 
            v-if="Toelichting.content.Funnel == funnel"
            class="flex-grid"
          >
            <div class="col-large l-mb-4">
              <h3 class="bstep__title">
                <span v-html=Toelichting.content.intro_header />
              </h3>
              <p class="">
                <span v-html=Toelichting.content.intro_tekst />
              </p>
            </div>
            <div class="col-small">
              <a 
                v-if="Toelichting.content.partnerLinktext"
                class="text-center btn-orange l-mb-3" :href=Toelichting.content.partnerURL target="_blank" rel="sponsored nofollow"> {{ Toelichting.content.partnerLinktext }} 
              </a>
            </div>
          </div>
          <div 
            v-if="Toelichting.content.Funnel == funnel"
            class="flex-grid col col-large"
          >
            <h4>
              <span v-html=Toelichting.content.step_header />
            </h4>
            <p>
              <span v-html=Toelichting.content.step_toelichting />
            </p>
            <a 
              v-if="Toelichting.content.blogLinktext"
              class="" :href="'../blog/' + Toelichting.content.blogURL" target="_blank" rel="sponsored nofollow">  {{ Toelichting.content.blogLinktext }} 
              <!-- <router-link :to="{name: 'BlogPagina', params: {postTitle:  }}"> {{ Toelichting.content.blogLinktext }} </router-link> -->
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>
<script>
import Header from "@/components/ComponentHeader";
import Footer from "@/components/ComponentFooter";
import { mapGetters } from "vuex";

export default {
  name: "MoreInfo",
  components: {
    Header,
    Footer
  },
  props: {
    funnel: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["getFunnel_toelichting"])

  }
};
</script>

<style scoped>
h2 {
  font-size: 44px;
  font-weight: 300;
  text-transform: uppercase;
  margin: 64px 0 ;
}

h3 {
  font-size: 26px;
  font-weight: 300;
  text-transform: uppercase;
  margin-bottom: 32px;
}

h4 {
  font-weight: bold;
}
.bottom {
  padding: 0 0 112px 0;
}
.top {
  margin: 64px 0 0 0;
}
.hyp {
  color: #CE182D;
}

.intro {
  font-size: 18px;
}

font-awesome-icon {
  font-size: 48px;
}

.container--stretch {
  align-items: stretch;
}

.coll-2--full {
  flex-basis: 50%;
  padding: 20px 50px;
  position: relative;
  height: 100vh;
  display: flex;
  justify-content: center;
}

.content:not(:last-child) {
  margin-bottom: 64px;
}

.coll-2--full p {
  font-size: 20px;
  margin-bottom: 20px;
}

.image {
  padding: 10%;
}

.step__title {
  font-size: 32px;
  display: inline-block;
}

.st0 {
  fill: transparent;
}

.box p {
  font-size: 16px;
  color: #fff;
  text-transform: uppercase;
}

.box:not(:first-of-type) {
  border-left: 1px solid #fff;
}
.video__bg {
  background-image: url(../isaluAssets/img/jpg/bg-uitleg-new.jpg);
  background-position: 80% 20%;
  background-size: cover;
  width: 100%;
  height: 100%;
  min-height: 900px;
  margin-bottom: 64px;
}

@media screen and (min-width: 1024px) {
  .video__bg {
    background-image: url(../isaluAssets/img/jpg/bg-uitleg-new-hires.jpg);
  }
}

.video__content {
  text-align: center;
  color: #fff;
}

.overlay {
  background-color: rgba(148, 176, 211, 1);
  height: 100%;
  width: 50%;
  position: absolute;
  top: 0;
  right: 0;
}

.btn {
  margin-top: 48px;
}

.slide-leave-active {
  transition: 0.25s cubic-bezier(0, 0, 0.2, 1);
}

.slide-enter-active {
  transition: 0.3s cubic-bezier(0, 0, 0.2, 1) 0.1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(100%, 0);
}

.mouse {
  position: relative;
  bottom: 40px;
  margin: 0 auto;
  height: 35px;
  width: 20px;
  border-radius: 10px;
  transform: translateY(150px);
  border: 2px solid white;
}
.mouse:after {
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 5px;
  left: 0;
  right: 0;
  margin: 0 auto;
  animation: mouse-move 1.4s ease-in-out infinite;
}

@keyframes mouse-move {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(12px);
  }
  100% {
    transform: translateY(0);
  }
}
@media (min-width: 240px) and (max-width: 720px) {
  h2 {
    font-size: 36px;
    margin-bottom: 32px;
  }
  .video__bg {
    margin-bottom: 0;    
  }
  .coll-2--full {
    flex-basis: 100%;
  }

  .content {
    margin-bottom: 20px;
  }

  .image {
    bottom: 0;
  }
  .second {
    order: 2;
  }
  .first {
    order: 1;
  }
  .overlay {
    width: 100%;
    position: relative;
    order: 3;
  }
  .flex-grid {
    margin: 0 2%;
    padding-bottom: 32px;
  }
}
</style>
